<template>
  <button class="simple-button" :class="disabled ? 'simple-button--disabled' : ''" :disabled="disabled" :id="`simple-button-${text.split(/\s/g).join('')}`">
    {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Submit'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">

.simple-button {
  border: 0;
  display: table;
  height: 34px;
  min-width: 80px;
  padding: 0 30px;
  border-radius: 5px;
  text-transform: uppercase;
  color: white;
  text-align: center;
  font-size: 14px;
  line-height: 34px;
  font-weight: bold;

  &:focus {
    outline: 0;
  }

  &:hover:not(:disabled) {
    color: color(yellow);
  }

  &--disabled {
    opacity: .4;
  }
}

</style>



// WEBPACK FOOTER //
// SimpleButton.vue?6408a4d0